var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 2.667C5.973 2.667 0 8.64 0 16s5.973 13.333 13.333 13.333S26.666 23.36 26.666 16 20.693 2.667 13.333 2.667zm0 25.6C6.56 28.267 1.066 22.774 1.066 16S6.559 3.733 13.333 3.733C20.106 3.733 25.6 9.226 25.6 16s-5.493 12.267-12.267 12.267z",
    fill: "#0B0C0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 12.8c0-2.347-1.92-4.267-4.267-4.267s-4.267 1.92-4.267 4.267c0 1.6.907 3.04 2.24 3.733l-2.24 6.4h8.533l-2.187-6.4c1.28-.747 2.187-2.133 2.187-3.733zm-1.493 9.067H10.56l1.707-4.96.32-.853-.8-.427a3.273 3.273 0 0 1-1.653-2.827c0-1.76 1.44-3.2 3.2-3.2s3.2 1.44 3.2 3.2c0 1.173-.64 2.24-1.653 2.773l-.8.427.267.853 1.76 5.013z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorLock);
export default __webpack_public_path__ + "static/media/door-lock.443cbaae264de3641f4dd05a8e9e23b6.svg";
export { ForwardRef as ReactComponent };